import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { TranslationActions, TranslationStore, STATUS } from 'Stores/translationStore'
import TranslationForm from 'Modules/translations/translationForm'

export default class TranslationCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [TranslationStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    TranslationActions.createEmptyTranslation()
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.TRANSLATION_FAILED) {
      toast.error('CREATE TRANSLATION FAILED', {
        autoClose: 3000,
        onClose: () => {
          TranslationActions.clearToast()
        }
      })
      TranslationActions.clearToast()
    }
    if (this.state.status === STATUS.TRANSLATION_SUCCESS) {
      toast.success('CREATED TRANSLATION SUCCESSFUL', {
        autoClose: 3000,
        onClose: () => {
          TranslationActions.clearToast()
        }
      })
      TranslationActions.clearToast(STATUS.IS_REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <TranslationForm />
      </React.Fragment>
    )
  }
}
